module.exports = __webpack_public_path__ + "img/4.6f3f1ee5.png";